import { Children, cloneElement, ReactNode } from "react";
import "../../styles/actionbar/bar.css";

type Props = {
  children: ReactNode | ReactNode;
};

const ActionBar = (props: Props) => {
  const children = Children.map(props.children, (child, index) => {
    if (!child) return;
    //@ts-ignore
    return cloneElement(child, {
      order: index,
    });
  });
  return (
    // root nav bar
    <div className={"actionBar"}>{children}</div>
  );
};

export { ActionBar };
